import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHeader } from "@/components/StatusBadge";
import { RecordsTable } from "@/components/records/RecordsTable";

const Block = ({ title, items, testid, empty }) => (
  <div className="rounded-lg border border-slate-200 bg-white shadow-sm" data-testid={testid}>
    <div className="px-4 py-3 border-b border-slate-200 font-display font-semibold text-sm">{title} <span className="text-slate-400 font-mono ml-1">{items?.length ?? ""}</span></div>
    {items && <RecordsTable items={items} empty={empty} />}
  </div>
);

export default function Approvals() {
  const { meta } = useAuth();
  const [mine, setMine] = useState(null);
  const [unassigned, setUnassigned] = useState(null);
  useEffect(() => {
    if (meta.permissions.approve) api.get("/records", { params: { mine: "assigned", status: "submitted,under_review", limit: 100 } }).then((r) => setMine(r.data.items));
    if (meta.permissions.assign || meta.permissions.approve) api.get("/records", { params: { mine: "unassigned", status: "submitted", limit: 100 } }).then((r) => setUnassigned(r.data.items));
  }, [meta]);
  return (
    <div className="space-y-6">
      <PageHeader eyebrow="Workflow" title="Approvals & queue" testid="approvals-title" />
      {meta.permissions.approve && <Block title="Assigned to me" items={mine} testid="approvals-mine" empty="No records awaiting your decision." />}
      <Block title="Unassigned submissions" items={unassigned} testid="approvals-unassigned" empty="Every submission has an approver." />
    </div>
  );
}
